export default "__VITE_ASSET__DKd4xz8k__"